<template>
  <ValidationObserver tag="tr" ref="form">
    <td>
      <button class="btn btn-xs btn-icon btn-light-primary" @click="onSave" :disabled="loading.save">
        <i class="fa fa-fw fa-save"></i>
      </button>
    </td>
    <td>
      <!-- <input-time2 v-model="item.hora"></input-time2> -->
      <InputTime
        v-model="item.hora"
        :vid="`hora_${item.idItinerario}`"
        :errorMode="'tooltip'"
        name="Hora"
        rules="time2"
        :inputClass="'form-control form-control-table text-center'"
      ></InputTime>
    </td>
    <td style="width: 65px">{{ item.codigo }}</td>
    <td>{{ item.servicio }}</td>
    <td>{{ item.pasajero }}</td>
    <td class="text-center">{{ item.nroAdultos }}</td>
    <td class="text-center">{{ item.nroNinos }}</td>
    <td>{{ item.hotel }}</td>
    <td>{{ item.agencia }}</td>
    <td>{{ item.vueloTourTren }}</td>
    <td>{{ item.restaurante }}</td>
    <td>
      <InputSelect
        v-model="item.idVehiculo"
        :reduce="(opt) => opt.idVehiculo"
        :vid="`vehiculo_${item.idItinerario}`"
        name="Móvil"
        :options="vehiculos"
        label="vehiculo"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <template v-if="containers.vehiculo">
        <template v-if="containers.vehiculo.propiedad == 1">
          <InputSelect
            v-model="item.idConductor"
            :reduce="(opt) => opt.idPersona"
            :vid="`conductor_${item.idItinerario}`"
            name="Conductor"
            :options="conductores"
            label="nombreCompleto"
            input-class="form-control-table"
          ></InputSelect>
        </template>
        <template v-else>
          <InputText
            v-model="form.otroConductor"
            :vid="`otro_conductor_${item.idItinerario}`"
            :errorMode="'tooltip'"
            name="Conductor"
            :inputClass="'form-control form-control-table'"
          ></InputText>
        </template>
      </template>
    </td>
    <td>
      <InputSelect
        v-model="item.idGuia"
        :reduce="(opt) => opt.idPersona"
        :options="guias"
        label="nombre"
        :vid="`guia_${item.idItinerario}`"
        name="Guía"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>
      <InputSelect
        v-model="item.idTransfer"
        :options="transfers"
        :reduce="(opt) => opt.idPersona"
        label="nombre"
        :vid="`transfer_${item.idItinerario}`"
        name="Transfer"
        input-class="form-control-table"
      ></InputSelect>
    </td>
    <td>{{ item.abreviatura }}</td>
    <td>{{ item.servicioTipo }}</td>
    <td style="min-width: 280px;">
      <InputTextArea :vid="`observaciones_${item.idItinerario}`" inputClass="form-control form-control-table" v-model="form.observaciones" :errorMode="'tooltip'" />
    </td>
  </ValidationObserver>
</template>
<script>
import InputTime from "../../modules/shared/components/InputTime.vue";
import InputText from "../../modules/shared/components/InputText.vue";
import InputTextArea from "../../modules/shared/components/InputTextArea.vue";
import InputSelect from "../../modules/shared/components/InputSelect.vue";
import InputTime2 from "@/components/InputTime2";
import { parseTime } from "../../modules/shared/helpers/time";
export default {
  props: {
    item: Object,
    guias: Array,
    vehiculos: Array,
    transfers: Array,
    conductores: Array,
  },
  components: {
    InputTime2,
    InputSelect,
    InputTextArea,
    InputText,
    InputTime,
  },
  data() {
    return {
      form: {
        observaciones: this.item.observaciones,
        otroConductor: this.item.otroConductor || "",
      },
      loading: {
        save: false,
      },
      containers: {
        vehiculo: null,
      },
    };
  },
  created() {
    const vm = this;

    if (vm.item.idVehiculo) {
      let vehiculo = vm.vehiculos.find((item) => item.idVehiculo == vm.item.idVehiculo);
      vm.containers.vehiculo = vehiculo;
    }
  },
  mounted() {
    const vm = this;

    vm.$watch("item.idVehiculo", (newVal) => {
      if (newVal) {
        let vehiculo = vm.vehiculos.find((item) => item.idVehiculo == newVal);
        vm.item.idConductor = vehiculo.idConductor || null;
        vm.containers.vehiculo = vehiculo;
        if (vehiculo.propiedad == 1) vm.form.otroConductor = "";
      } else {
        vm.containers.vehiculo = null;
        vm.form.otroConductor = "";
      }
    });
  },
  methods: {
    async onSave() {
      const vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          icon: "warning",
          title: "Revise y verifique los campos en rojo",
        });

        return;
      }

      const time = parseTime(vm.item.hora);

      const fd = {
        time: time || null,
        idGuia: vm.item.idGuia,
        idTransfer: vm.item.idTransfer,
        idVehiculo: vm.item.idVehiculo,
        idConductor: vm.item.idConductor,
        observations: vm.form.observaciones,
        otherDriver: String(vm.form.otroConductor || "").trim(),
      };

      vm.axios
        .put(`/itinerarios/privados/${vm.item.idItinerario}`, fd)
        .then((response) => {
          vm.$toast.fire("Registro actualizado", "", "success");

          vm.item.hora = time;

          vm.$emit("update", {
            ...vm.item,
            otroConductor: fd.otherDriver,
            observaciones: fd.observations,
          });
        })
        .catch((err) => {
          console.log({ err });
          if (err?.response?.errorsForHumans) {
            vm.$swal.fire({
              icon: "warning",
              html: err.response.errorsForHumans,
            });
          }
        });
    },
  },
};
</script>
